<template>
  <div class="home">
    <div class="floating-component">
      <!-- 悬浮内容 -->
      <I18n/>
    </div>
    <a href="https://www.tokenpocket.pro/?from=scatter-demo-eosjs2"></a>
    <img alt="znl logo" style="height:30px;" src="../assets/ic_launcher_round.png">
    <h1>ZNL智能支付</h1>
    <!-- <HelloWorld/> -->
    
    <TransferPayment/>
  </div>
</template>

<script>
// @ is an alias to /src
import TransferPayment from "@/components/TransferPayment.vue";
import I18n from "@/components/I18n.vue"
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: "home",
  components: {
    // HelloWorld,
    TransferPayment,
    I18n,
  }
};
</script>

<style scoped>
.floating-component {
  position: fixed; /* 固定位置 */
  top: 5%;
  bottom: 5%; /* 下边距 */
  /* right: 1%; 右边距 */
  padding: 0;
  /* border-radius: 50%; 圆角 */
  z-index: 10000; /* 设置 z-index 确保悬浮在顶层 */
}
</style>